<template>
    <div class="table-results">
        <div class="table-result">
            <p class="left-td bottom-left-heading">Internal Consultants</p>
        </div>
        <div class="table-result">
            <p class="left-td bottom-left-heading">External Consultants</p>
        </div>
        <div class="table-result">
            <p class="left-td bottom-left-heading">Total</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Results"
    }
</script>

<style scoped>

</style>
